module.exports = __webpack_public_path__ + "0e9654bdd39b625b67e6884037dc34f4.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/cancel-medium-light.svg
// module id = 477
// module chunks = 74